import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ahilandoc from '../../../../assets/images/Doctorsimages/dr.Ahilan_new.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const AhilanDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Ahilan Murugadas | Best Homeopathy & Cosmetic Doctor in Gerugambakkam Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Ahilan Murugadas (BHMS, FMC, PGDDN), male homeopathy, cosmetic and nutrition doctor at H-Cura Multispeciality Clinic, Gerugambakkam, Chennai. Expert in skin, hair fall, PCOS, thyroid, chronic illness & holistic healthcare near Porur, Ramapuram & Kundrathur."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Gerugambakkam Chennai, male homeopathy doctor in Chennai, cosmetic doctor in Gerugambakkam Chennai, homeopathy doctor near Porur and Ramapuram, holistic doctor in Kundrathur and Valasaravakkam, facial aesthetics doctor in Chennai, diet and nutrition doctor in Gerugambakkam, nutrition-focused homeopathy doctor in Chennai, homeopathy doctor for hair fall in Chennai, natural skin and hair specialist in Gerugambakkam"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10; 
      const marginRight = 10; 
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.AHILAN_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Ahilan Murugadas</span>
                  <span className="veenadoc-title-credentials">(BHMS, FMC, PGDDN)</span>
                  <span className="veenadoc-title-location">Gerugambakkam, Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Highly qualified and compassionate Consultant in Homeopathy, Cosmetology, and Diet & Nutrition at H-Cura 
                    Multispeciality Clinic. Known for his patient-centric approach, he has become one of the most trusted names 
                    for those searching for the best homeopathy doctor in Gerugambakkam Chennai, combining classical homeopathy 
                    with modern cosmetology and nutrition for safe, natural, and long-lasting treatments.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={ahilandoc} alt="Dr. Ahilan Murugadas – Homeopathy, Cosmetic & Nutrition Doctor in Gerugambakkam, Chennai" className="veenadoc-doctor-image" title='Dr. Ahilan Murugadas | Best Male Homeopathy Doctor in Gerugambakkam Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Ahilan Murugadas</h2>
                  <p>
                    Dr. Ahilan earned his Bachelor of Homeopathic Medicine and Surgery (BHMS) from Vinayaka Mission Homoeopathic 
                    Medical College & Hospital, establishing a strong foundation in holistic medicine. To expand his knowledge in 
                    aesthetic medicine, he pursued a Fellowship in Medical Cosmetology (FMC) from ILAMED, where he gained expertise 
                    in advanced skin and hair treatments.
                  </p>
                  <p>
                    His commitment to comprehensive care led him to complete a Postgraduate Diploma in Diet and Nutrition (PGDDN) 
                    from Peachtree Academy, making him one of the few doctors in Chennai who integrates homeopathy, cosmetology, 
                    and nutrition into a single practice. This unique combination has made him a sought-after homeopathy doctor 
                    for chronic diseases, cosmetic doctor for skin and hair issues, and diet and nutrition specialist in Gerugambakkam.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Experience</h2>
                  <p>
                    Earlier in his career, he worked as a Medical Officer at Sairam Homoeopathic Medical College & Research Centre, 
                    where he supervised patient care, coordinated health camps, and guided students through academic and clinical 
                    training. This experience sharpened his skills in managing diverse conditions and deepened his passion for 
                    holistic healthcare.
                  </p>
                  <p>
                    Today, his patients describe him as approachable, empathetic, and highly professional, making him a preferred 
                    choice for those searching online for male homeopathy doctors in Chennai or a holistic doctor in Gerugambakkam.
                  </p>
                </div>

                 <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Ahilan has gained recognition as a trichology doctor in Chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    His expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, FMC, PGDDN</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">4+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy, Cosmetology & Nutrition</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Gerugambakkam, Chennai</span>
                    </div>
                    
                  </div>
                </div>

                {/* Expertise in Chronic Conditions */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic Diseases</h2>
                  <p>
                    At H-Cura Gerugambakkam, Dr. Ahilan treats a wide range of chronic diseases, including arthritis, asthma, 
                    thyroid disorders, digestive problems, diabetes complications, hypertension, and migraines. Patients from 
                    Gerugambakkam, Porur, Kundrathur, Ramapuram, and Valasaravakkam often consult him for long-term solutions 
                    that focus on the root cause rather than temporary symptom relief.
                  </p>
                  <p>
                    For those looking for a homeopathy clinic in Gerugambakkam Chennai, his expertise ensures reliable care 
                    for complex and recurring conditions with a patient-centric approach that addresses the whole person, 
                    not just the symptoms.
                  </p>
                </div>

                {/* Cosmetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Leading Cosmetic Doctor in Gerugambakkam</h2>
                  <p>
                    He is also recognized as a cosmetic doctor in Gerugambakkam Chennai, offering natural and advanced treatments 
                    for skin and hair concerns. Patients dealing with acne, pigmentation, scars, eczema, psoriasis, dermatitis, 
                    and vitiligo often search for a homeopathy skin doctor near Porur or a facial aesthetics doctor in Chennai, 
                    and they find effective, side-effect-free treatments with him.
                  </p>
                  <p>
                    His fellowship training allows him to provide solutions for acne scar reduction, pigmentation control, 
                    anti-aging therapies, wrinkle reduction, and skin rejuvenation. Patients who visit H-Cura Gerugambakkam 
                    for cosmetic and aesthetic treatments value his ability to blend natural remedies with modern techniques, 
                    achieving visible results that look and feel natural.
                  </p>
                </div>

                {/* Hair Care Solutions */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Hair Care Solutions</h2>
                  <p>
                    Hair problems such as chronic hair fall, dandruff, scalp infections, and premature greying are also 
                    effectively managed by Dr. Ahilan. Many patients searching for a homeopathy doctor for hair fall in 
                    Gerugambakkam Chennai or a natural trichology doctor near Kundrathur and Ramapuram rely on his expertise.
                  </p>
                  <p>
                    By combining homeopathy with nutritional guidance, he ensures that patients regain not only healthy hair 
                    growth but also overall scalp health. His approach addresses underlying causes like stress, hormonal 
                    imbalances, and nutritional deficiencies for lasting results.
                  </p>
                </div>

                {/* Nutrition Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Diet & Nutrition Specialization</h2>
                  <p>
                    With his qualification in diet and nutrition, Dr. Ahilan stands out as a nutrition-focused homeopathy doctor 
                    in Gerugambakkam Chennai. He provides personalized diet plans and lifestyle counseling to patients struggling 
                    with obesity, diabetes, PCOS, infertility, and hypertension.
                  </p>
                  <p>
                    His ability to combine diet therapy with homeopathy gives patients a holistic path toward long-term wellness. 
                    Many who search for a diet and nutrition doctor in Gerugambakkam or a holistic doctor near Porur and 
                    Valasaravakkam choose him for his integrated, scientific, and practical approach.
                  </p>
                </div>

                {/* Service Areas */}
                <div className="veenadoc-article-block">
                  <h2>Serving Chennai's Growing Healthcare Needs</h2>
                  <p>
                    In Chennai, where patients increasingly prefer natural and non-invasive alternatives, online queries such 
                    as best homeopathy doctor in Gerugambakkam, male homeopathy doctor near me, cosmetic doctor in Porur, 
                    holistic doctor in Ramapuram, homeopathy doctor for hair fall in Valasaravakkam, and nutrition doctor 
                    in Kundrathur Chennai often lead patients to his profile.
                  </p>
                  <p>
                    His ability to integrate homeopathy, cosmetology, and nutrition gives him a competitive edge in providing 
                    comprehensive care under one roof, making him a preferred choice for families seeking holistic healthcare 
                    solutions.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Philosophy</h2>
                  <p>
                    Patients consistently praise Dr. Ahilan for his clarity in communication, empathetic listening, and 
                    willingness to explain every step of treatment. He strongly believes that "True healthcare is not just 
                    curing illness but helping patients achieve balance in body, mind, and lifestyle."
                  </p>
                  <p>
                    This philosophy has helped him build trust and long-term relationships with his patients, making him 
                    a highly recommended homeopathy doctor in Gerugambakkam who delivers not just treatment, but comprehensive 
                    wellness solutions.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Ahilan for Integrated Healthcare</h2>
                  <p>
                    For residents of Gerugambakkam, Porur, Kundrathur, Valasaravakkam, Ramapuram, and nearby Chennai areas, 
                    Dr. Ahilan Murugadas is fast becoming a trusted name in holistic healthcare. Whether it's a patient 
                    searching for a homeopathy doctor for arthritis in Gerugambakkam, a cosmetic doctor for acne and 
                    pigmentation near Porur, a hair fall treatment specialist in Ramapuram, or a diet and nutrition doctor 
                    near Kundrathur Chennai, his expertise offers safe, effective, and lasting results.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His mission:</strong> To make healthcare natural, side-effect free, and transformative. By combining 
                    homeopathy, cosmetology, and nutrition therapy, he helps patients not only recover from illnesses but also 
                    achieve long-term wellness and confidence.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "True healthcare is not just curing illness but helping patients achieve balance in body, mind, and lifestyle"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Ahilan Murugadas's Philosophy of Care</p>
                  </div>
                  <p>
                    He believes that comprehensive wellness requires addressing not just symptoms but the underlying causes 
                    of illness. This integrated approach combining homeopathy, cosmetology, and nutrition has positioned 
                    him among the most trusted holistic doctors in Chennai.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location & Service Areas</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Gerugambakkam</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">🏥</div>
                    <div className="veenadoc-location-details">
                      <h4>Service Areas</h4>
                      <p>Porur, Ramapuram, Kundrathur, Valasaravakkam</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience integrated healthcare with Dr. Ahilan's comprehensive approach combining homeopathy, cosmetology & nutrition.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>


      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default AhilanDoc
